module.exports = __webpack_public_path__ + "assets/img/2201.a122cfc2.png";